<template>
  <v-card>
    <v-row cols="12" no-gutters v-if="$vuetify.breakpoint.mdAndUp">
      <v-col cols="1" class="pa-0 ma-0">
        <button left class="scrollButton" @click="scrollLeft();">
          <div id="liveHeader">
            <v-icon id="liveBlink">fas fa-rss</v-icon>
            <br />LIVE:
          </div>
          <div id="leftIcon">
            <i class="fas fa-chevron-left"></i>
          </div>
        </button>
      </v-col>
      <v-col cols="10" class="pa-0 ma-0">
          <div class="content" ref="content">
            <div class="liveFeed" v-for="card in localLive" :key="card.id">
              <!-- TWITTER CARD-->
              <v-card
                v-if="card.ArticleType=='twitter'"
                class="feedCard pl- pr-2 pt-2 pb-0 d-flex flex-column "
                flat
                tile
                >
                <v-card
                  class="mt-0 pt-0"
                  flat
                  tile
                  :to="{
                name: `frontpage`,
                params: { articleid: card.id },
               }"
                >
                  <v-row class="ma-0 pa-0">
                    <v-col class="ma-0 pl-2 pr-1 pt-0 pb-0">
                      <span
                        class="dateText"
                        :style="$vuetify.breakpoint.smAndDown?'display:block':''"
                      >{{card.Date}}</span>
                      <v-card-title class="pa-0">
                        <v-icon class="twitterIcon" left>fab fa-twitter</v-icon>
                        <p
                          class="font-weight-bold subtitle-2 pt-1 mb-0 pb-0 twitterTitle"
                          style="display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden;"
                          v-html="card.Title"
                        ></p>
                      </v-card-title>
                    </v-col>
                  </v-row>

                  <v-row class="ma-0 pa-0">
                    <v-col class="ma-0 pa-2 d-flex">
                      <div
                        class="cardContent"
                        style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; "
                        v-html="card.Content"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>

              <!--RSS CARD-->
              <v-card
                v-if="card.ArticleType=='rss_article'"
                class="feedCard pl-2 pr-2 pt-2 pb-0  d-flex flex-column"
                flat
                tile
               >
                <v-card
                  class="mt-0 pt-0"          
                  flat
                  tile
                  :to="{
                name: `frontpage`,
                params: { articleid: card.id },
               }"
                >
                  <v-row class="ma-0 pa-0">
                    <v-col class="ma-0 pl-2 pr-1 pt-0 pb-0">
                      <span
                        class="dateText"
                        :style="$vuetify.breakpoint.smAndDown?'display:block':''"
                      >{{card.Date}}</span>
                      <p
                        class="font-weight-bold subtitle-2 pt-1 mb-0 pb-0 rssTitle"
                        style="display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden;"
                        v-html="card.Title"
                      ></p>
                    </v-col>
                  </v-row>

                  <v-row class="ma-0 pa-0">
                    <v-col class="ma-0 pa-0 pa-2 d-flex">
                      <v-img
                        v-if="card.MediaData && card.MediaData.length > 0"
                        class="mr-3 rssImg"
                        :src="card.MediaData[0]['s3url']"
                      ></v-img>
                      <div
                        class="cardContent"
                        style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;"
                        v-html="card.Content"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>
          </div>
        </div>
      </v-col>
      <v-col md="1" class="pa-0 ma-0">
        <button right class="scrollButton" @click="scrollRight(); hideLiveHeader();">
          <i class="fas fa-chevron-right"></i>
        </button>
       </v-col>
    </v-row>

    <!--For phone-->
    <v-row cols="12" no-gutters v-else>
      <v-col cols="1" class="pa-0 ma-0">
        <button left class="scrollButton" @click="scrollLeft();">
          <div id="liveHeader">
            <v-icon id="liveBlink">fas fa-rss</v-icon>
          </div>
          <div id="leftIcon">
            <i class="fas fa-chevron-left"></i>
          </div>
        </button>
      </v-col>
      <v-col cols="10" class="pa-0 ma-0">
          <div class="content" ref="content">
            <div class="liveFeed" v-for="card in localLive" :key="card.id">
              <!-- TWITTER CARD-->
              <v-card
                v-if="card.ArticleType=='twitter'"
                class="feedCard pl- pr-2 pt-2 pb-0 d-flex flex-column "
                flat
                tile
                >
                <v-card
                  class="mt-0 pt-0"
                  flat
                  tile
                  :to="{
                name: `frontpage`,
                params: { articleid: card.id },
               }"
                >
                  <v-row class="ma-0 pa-0">
                    <v-col class="ma-0 pl-2 pr-1 pt-0 pb-0">
                      <span
                        class="dateText"
                        :style="$vuetify.breakpoint.smAndDown?'display:block':''"
                      >{{card.Date}}</span>
                      <v-card-title class="pa-0">
                        <v-icon class="twitterIcon" left>fab fa-twitter</v-icon>
                        <p
                          class="font-weight-bold subtitle-2 pt-1 mb-0 pb-0 twitterTitle"
                          style="display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden;"
                          v-html="card.Title"
                        ></p>
                      </v-card-title>
                    </v-col>
                  </v-row>

                  <v-row class="ma-0 pa-0">
                    <v-col class="ma-0 pa-2 d-flex">
                      <div
                        class="cardContent"
                        style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; "
                        v-html="card.Content"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>

              <!--RSS CARD-->
              <v-card
                v-if="card.ArticleType=='rss_article'"
                class="feedCard pl-2 pr-2 pt-2 pb-0  d-flex flex-column"
                flat
                tile
               >
                <v-card
                  class="mt-0 pt-0"          
                  flat
                  tile
                  :to="{
                name: `frontpage`,
                params: { articleid: card.id },
               }"
                >
                  <v-row class="ma-0 pa-0">
                    <v-col class="ma-0 pl-2 pr-1 pt-0 pb-0">
                      <span
                        class="dateText"
                        :style="$vuetify.breakpoint.smAndDown?'display:block':''"
                      >{{card.Date}}</span>
                      <p
                        class="font-weight-bold subtitle-2 pt-1 mb-0 pb-0 rssTitle"
                        style="display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden;"
                        v-html="card.Title"
                      ></p>
                    </v-col>
                  </v-row>

                  <v-row class="ma-0 pa-0">
                    <v-col class="ma-0 pa-0 pa-2 d-flex">
                      <v-img
                        v-if="card.MediaData && card.MediaData.length > 0"
                        class="mr-3 rssImg"
                        :src="card.MediaData[0]['s3url']"
                      ></v-img>
                      <div
                        class="cardContent"
                        style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;"
                        v-html="card.Content"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>
          </div>
        </div>
      </v-col>
      <v-col cols="1" class="pa-0 ma-0">
        <button right class="scrollButton" @click="scrollRight(); hideLiveHeader();">
          <i class="fas fa-chevron-right"></i>
        </button>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    liveData: {
      type: Array,
    },
  },

  computed: {
    localLive() {
      let data = JSON.parse(JSON.stringify(this.liveData));
      let res = [];
      for (const el of data) {
        //Remove <img> tag etc. which ruins the display totally
        el.Content = el.Content.replace(/<\/?[^>]+(>|$)/g, "");
        if (el.PubDate) {
          el.Date = this.parseDate(el.PubDate);
        } else if (el.Created) {
          el.Date = this.parseDate(el.Created);
        }

        res.push(el);
      }
      return res;
    },
  },

  methods: {
    parseDate(published) {
      //This date is visible outside the cards. Format examples:
      //Less than 24h ago: 20m (if under 60m ago), else 20h
      //This year: Jun 10
      //Longer time ago: Jun 10, 2019
      published = new Date(published);
      let now = new Date();
      let diff = now.getTime() - published.getTime();

      let hoursAgo = diff / 3600000;
      if (hoursAgo < 24) {
        let minAgo = diff / 60000;
        if (minAgo < 60) {
          return Math.floor(minAgo) + "m";
        } else {
          return Math.floor(hoursAgo) + "h";
        }
      } else {
        const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
          published
        );
        const mo = new Intl.DateTimeFormat("en", { month: "long" }).format(
          published
        );
        const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
          published
        );
        if (published.getYear == now.getYear) {
          return mo + " " + da; //e.g. Jul 28
        } else {
          return mo + " " + da + ", " + ye; //e.g. Jul 28, 2019
        }
      }
    },

    /*Scrollable buttons - link: https://codepen.io/Jayesh_v/pen/oMgwRO*/
    scrollTo(element, scrollPixels, duration) {
      let scrollPos = element.scrollLeft;
      // Condition to check if scrolling is required
      if (
        !(
          (scrollPos === 0 || scrollPixels > 0) &&
          (element.clientWidth + scrollPos === element.scrollWidth ||
            scrollPixels < 0)
        )
      ) {
        // Get the start timestamp
        const startTime =
          "now" in window.performance
            ? performance.now()
            : new Date().getTime();

        function scroll(timestamp) {
          //Calculate the timeelapsed
          const timeElapsed = timestamp - startTime;
          //Calculate progress
          const progress = Math.min(timeElapsed / duration, 1);
          //Set the scrolleft
          element.scrollLeft = scrollPos + scrollPixels * progress;
          //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
          if (timeElapsed < duration) {
            //Request for animation
            window.requestAnimationFrame(scroll);
          } else {
            return;
          }
        }
        //Call requestAnimationFrame on scroll function first time
        window.requestAnimationFrame(scroll);
      }
    },

    //Change scrollamount depending on screen width
    scrollLeft() {
      var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
      var scrollAmount;

      if (width > 1024) {
        scrollAmount = -1200;
      }
      else if(width > 768) {
        scrollAmount = -600;
      }
      else {
        scrollAmount= -300;
      }

      const content = this.$refs.content;
      this.scrollTo(content, scrollAmount, 600);
    },

    scrollRight() {
      var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
      var scrollAmount;

      if (width > 1024) {
        scrollAmount = 1200;
      }
      else if(width > 768) {
        scrollAmount = 600;
      }
      else {
        scrollAmount= 300;
      }

      const content = this.$refs.content;
      this.scrollTo(content, scrollAmount, 600);
    },

    //hide live icon when scroll is clicked
    hideLiveHeader: function () {
      //Hide the live icon header
      var header = document.getElementById("liveHeader");
      header.style.display = "none";
      //Show button to scroll back
      var icon = document.getElementById("leftIcon");
      icon.style.display = "block";
    },
  },
};
</script>

<style scoped>
#leftIcon {
  display: none;
}

.scrollButton {
  font-size: 2rem;
  height: 100%;
  width: 100%;
}
.scrollButton:hover {
  color: #1976d2;
}

#liveHeader {
font-size: 1rem;
font-weight: bold;
}

/*--Icon bling--*/
#liveBlink {
  animation: blinkingBackground 3s infinite;
  font-size: 2rem;
  padding-bottom: 2px;
}
@keyframes blinkingBackground {
  0% {
    color: #e4000f;
  }
  50% {
    color: #7e0303;
  }
  100% {
    color: #e4000f;
  }
}
.content::-webkit-scrollbar {
    display: none;
}

.content {
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  white-space: nowrap;
  position: relative;
}

.liveFeed {
  cursor: pointer;
  display: inline-block;
  *display: inline; /* For IE7*/
  *zoom: 1; /* For IE7*/
  width: 300px;
  height: 110px;
}

.feedCard {
  border-right: ridge 1px #c8c8c8;
  height: 100%;
}

.dateText {
  color: #666;
  font-size: 0.8em;
}
.twitterIcon {
  color: #1da1f2;
  font-size: 1em;
}

.twitterTitle {
  font-size: 0.8em;
  font-weight: bold;
}

.cardContent {
  font-size: 0.8rem;
}

.noBorder {
  border: 0 !important;
}

.rssImg {
  width: 45px;
  height: 45px;
}

.rssTitle {
  height: 52px !important;
}

@media (max-width: 600px) {
  #liveBlink {
    font-size: 1.5rem;
  }
  .scrollButton{
    font-size: 1.5rem;
  }
}

</style>

